import { useTranslate } from '@ur-solutions/react-hooks'
import styled, { useTheme } from 'styled-components'

const ColorDot = styled.span<{ color: string }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: ${props => props.color};
  margin-right: 2px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-left: 1rem;
  margin-top: 0.5rem;
  background-color: ${props => props.theme.colors.background};
`

export const CalendarColorExplanation: React.FC = () => {
  const translations = useTranslate({
    itemThatOnlyContainsApprovedWorkPeriods:
      'salary.item-that-only-contains-approved-work-periods',
    itemThatContainsUnapprovedWorkPeriods:
      'salary.item-that-contains-unapproved-work-periods',
    itemThatContainsUnassignedAndUnapprovedWorkPeriods:
      'salary.item-that-contains-unassigned-and-unapproved-work-periods',
  })

  const theme = useTheme()

  return (
    <Wrapper>
      <span>
        <ColorDot color={theme.colors.green} />{' '}
        {translations.itemThatOnlyContainsApprovedWorkPeriods}
      </span>
      <span>
        <ColorDot color={theme.colors.orange} />{' '}
        {translations.itemThatContainsUnapprovedWorkPeriods}
      </span>
      <span>
        <ColorDot color={theme.colors.red8} />{' '}
        {translations.itemThatContainsUnassignedAndUnapprovedWorkPeriods}
      </span>
    </Wrapper>
  )
}
